import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import {
  UNSCORED_SLEEP_STUDY_COLLECTION,
  SCORED_SLEEP_STUDY_COLLECTION,
} from "./sleepStudyFiles";

export const loadPatientSleepStudyFiles = async (hn) => {
  const collections = [UNSCORED_SLEEP_STUDY_COLLECTION, SCORED_SLEEP_STUDY_COLLECTION];
  const snapshots = await Promise.all(
    collections.map((name) => getDocs(collection(db, "patients", hn, name))),
  );

  return snapshots.flatMap((snapshot, index) => snapshot.docs.map((row) => ({
    id: row.id,
    ...row.data(),
    fileCollection: collections[index],
  })));
};
